module.exports = __webpack_public_path__ + "static/media/CasaAzul.dfaaa224.png";